import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';
import { CrowdCountObserved } from '../../model/crowd-count-observed';

@Injectable({
  providedIn: 'root'
})
export class AkitaHTTPCrowdCountObservedService  extends GenericAkitaHTTPService<CrowdCountObserved> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'CrowdCountObserved',
        options: 'keyValues',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'CrowdCountObserved', options);
  }
}
